// extracted by mini-css-extract-plugin
module.exports = {"AddCardControl":"addCard_AddCardControl__hbDWH","ButtonWrapper":"addCard_ButtonWrapper__3zw3-"};